import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddNewService from './AddNewService';

export default function ServiceFormButton({
    id
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            <Button
                color="primary"
                size="sm"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                Edit
      </Button>
            {isUpdating && (
                <AddNewService
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit Service"
                    visible={isUpdating}
                />
            )}
        </div>
    );
}

